"use strict";

angular.module("customer")

.config(function($stateProvider, $urlRouterProvider, APP_OWNER, appConfig) {
    console.log("Loading stateProvider states");
    $stateProvider
    .state("home", {
        url: "/home?groupInvite",
        templateUrl: require("customer/sections/home/home.html"),
        css: require("customer/sections/home/home.useable.scss"),
        controller: "SectionHome",
        controllerAs: "homeCtrl",
        authenticate: true,
        hideBackButton: true,
        defaultSearchSection: "stocks",
        title: function(gettextCatalog) {
            var title = gettextCatalog.getString("Together business is made easier");

            if (APP_OWNER === "jemangequebec") {
                title = gettextCatalog.getString("JEMANGEQUEBEC_MOTO");
            }
            else if (APP_OWNER === "gromec") {
                title = gettextCatalog.getString("TOGETHER FOR YOUR SUCCESS");
            }
            else if (APP_OWNER === "atlantis") {
                title = gettextCatalog.getString("ATLANTIS TOGETHER FOR YOUR SUCCESS");
            }
            else if (APP_OWNER === "bloom") {
                title = gettextCatalog.getString("BLOOM CONNECT");
            }
            // TODO WHITE_LABEL: duplicate previous IF

            return title;
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title home");
            }
        }
    })
    .state("login", {
        url: "/login?username&state?retailer&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&unpaid_invoices",
        templateUrl: require("customer/sections/auth/login.html"),
        css: require("customer/sections/auth/login.useable.scss"),
        controller: "SectionLogin",
        authenticate: false,
        hideBackButton: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Login");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title login");
            },
            description: function(gettextCatalog) {
                var description = gettextCatalog.getString("meta description login");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description login");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description login");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description login");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description login");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords login");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords login");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords login");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords login");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta keywords login");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("notification-history", {
        url: "/notification-history?filterUnread",
        templateUrl: require("customer/sections/notification/notification-history.html"),
        controller: "NotificationHistoryController",
        controllerAs: "notificationHistoryCtrl",
        authenticate: true,
        allowAll: true,
        params: {
            forceModalRedirect: null
        },
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Notifications");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Notifications");
            }
        }
    })
    .state("vendors", {
        url: "/vendors?search&categories",
        templateUrl: require("customer/sections/vendors-list/vendor-list.html"),
        authenticate: true,
        defaultSearchSection: "vendors",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Vendors");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Vendors");
            }
        }
    })
    .state("myOrders", {
        url: "/myOrders?search",
        templateUrl: require("customer/sections/order/order-list.html"),
        css: require("customer/sections/order/order-list.useable.scss"),
        controller: "SectionMyOrders",
        authenticate: true,
        defaultSearchSection: "myOrders",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Orders");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Orders");
            }
        }
    })
    .state("orderDetails", {
        url: "/orderDetails/:id",
        templateUrl: require("customer/sections/order/order-detail.html"),
        controller: "SectionOrderDetails",
        controllerAs: "orderDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "myOrders",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Order Details");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Order Details");
            }
        }
    })
    .state("orderTemplateList", {
        url: "/templates?search&page",
        templateUrl: require("customer/sections/order-template/order-template-list.html"),
        controller: "OrderTemplateListController",
        controllerAs: "orderTemplateListCtrl",
        authenticate: true,
        defaultSearchSection: "orderTemplateList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Templates");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Templates");
            }
        }
    })
    .state("orderTemplateDetails", {
        url: "/template/:id",
        templateUrl: require("customer/sections/order-template/order-template-details.html"),
        controller: "OrderTemplateDetailsController",
        controllerAs: "orderTemplateDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "orderTemplateList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Template Details");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Template Details");
            }
        }
    })
    .state("orderConfirmation", {
        url: "/order-confirmation",
        templateUrl: require('customer/sections/order/order-confirmation.html'),
        controller: "OrderConfirmationController",
        controllerAs: "orderConfirmationCtrl",
        authenticate: true,
        params: {
            order: null,
            display_error_message: false,
            show_view_invoices_button: false,
            show_invoice_print_buttons: false
        },
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Order Confirmation");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Order Confirmation");
            }
        }
    })
    .state("invoiceAttachments", {
        url: "/invoice/:id/attachments",
        templateUrl: require("customer/sections/invoice-attachment/invoice-attachment.html"),
        controller: "InvoiceAttachmentController",
        controllerAs: "invoiceAttachmentCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoice Attachments");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Invoice Attachments");
            }
        }
    })
    .state("noOrderNotificationConfirmation", {
        url: "/no-order-notification/:token",
        templateUrl: require("customer/sections/order/no-order-notification/no-order-notification.html"),
        controller: "SectionNoOrderNotification",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("No Order Confirmation");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("No Order Confirmation");
            }
        }
    })
    .state("commissionList", {
        url: "/commissions?invoice_date_start&invoice_date_end",
        templateUrl: require("customer/sections/commission/commission-list.html"),
        controller: "CommissionListController",
        controllerAs: "CommissionListCtrl",
        css: require("customer/sections/commission/commission-list.component.scss"),
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Commissions");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Commissions");
            }
        }
    })
    .state("depositSlipList", {
        url: "/deposit-slip?creation_date_start&creation_date_end",
        templateUrl: require("customer/sections/deposit-slip/deposit-slip-list.html"),
        controller: "DepositSlipListController",
        controllerAs: "depositSlipListCtrl",
        authenticate: true,
        defaultSearchSection: "paymentList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Deposit Slip");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Deposit Slip");
            }
        }
    })
    .state("invoiceList", {
        url: "/invoices?search&page&tab&ordering&status&invoice_date_start&invoice_date_end&vendor&payment_due_date_start&payment_due_date_end&payment_due_filter",
        templateUrl: require("customer/sections/invoice/invoice-list.html"),
        controller: "InvoiceListController",
        controllerAs: "invoiceListCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Invoices");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Invoices");
            }
        }
    })
    .state("invoiceDetails", {
        url: "/invoice/:id",
        templateUrl: require("customer/sections/invoice/invoice-detail.html"),
        controller: "SectionInvoiceDetails",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoice Details");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Invoice Details");
            }
        }
    })
    .state("invoiceCopy", {
        url: "/invoice/copy/:id",
        templateUrl: require("customer/sections/invoice-copy/invoice-copy.html"),
        controller: "InvoiceCopyController",
        authenticate: false,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invoice Copy");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Invoice Copy");
            }
        }
    })
    .state("inviteOwner", {
        url: "/invite/:invoice_uuid",
        templateUrl: require("customer/sections/invoice/invite-owner-form.html"),
        controller: "OwnerFormController",
        controllerAs: "OwnerFormCtrl",
        authenticate: false,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Invite Owner");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Invite Owner");
            }
        }
    })
    .state("paymentList", {
        url: "/payments?search&page&status&status_date_start&status_date_end&creation_date_start&creation_date_end&method",
        templateUrl: require("customer/sections/payment/payment-list.html"),
        controller: "PaymentListController",
        controllerAs: "paymentListCtrl",
        authenticate: true,
        defaultSearchSection: "paymentList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payments");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Payments");
            }
        }
    })
    .state("paymentDetails", {
        url: "/payment/:id",
        templateUrl: require("customer/sections/payment/payment-details.html"),
        controller: "PaymentDetailsController",
        controllerAs: "paymentDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "paymentList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payments");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Payments");
            }
        }
    })
    .state("payment", {
        url: "/invoices/unpaid?selected&selectAll",
        templateUrl: require("customer/sections/payment/payment.html"),
        controller: "paymentController",
        controllerAs: "paymentCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payments");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Payments");
            }
        }
    })
    .state("userManagementList", {
        url: "/users?page&search",
        templateUrl: require("customer/sections/user-management/user-management-list.html"),
        controller: "UserManagementListController",
        controllerAs: "userManagementListCtrl",
        authenticate: true,
        defaultSearchSection: "userManagementList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("User Management");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("User Management");
            }
        }
    })
    .state("userManagementForm", {
        url: "/users/:id?is_owner",
        templateUrl: require("customer/sections/user-management/user-management-form.html"),
        controller: "UserManagementFormController",
        controllerAs: "userManagementFormCtrl",
        authenticate: true,
        defaultSearchSection: "userManagementList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("User Management");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("User Management");
            }
        }
    })
    .state("goodsReceiptList", {
        url: "/goods-receipts?search&page&status&creation_date_start&creation_date_end&transmitted_date_state&transmitted_date_end",
        templateUrl: require("customer/sections/goods-receipt/goods-receipt-list.html"),
        controller: "GoodsReceiptListController",
        controllerAs: "goodsReceiptListCtrl",
        authenticate: true,
        defaultSearchSection: "goodsReceiptList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Goods Receipts");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Goods Receipts");
            }
        }
    })
    .state("goodsReceiptDetails", {
        url: "/goods-receipt/:id",
        templateUrl: require("customer/sections/goods-receipt/goods-receipt-details.html"),
        controller: "GoodsReceiptDetailsController",
        controllerAs: "goodsReceiptDetailsCtrl",
        authenticate: true,
        defaultSearchSection: "goodsReceiptDetails",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Goods Receipt Details");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Goods Receipt Details");
            }
        }
    })
    .state("goodsTransferList", {
        url: "/goods-transfers?search&page&creation_date_start&creation_date_end",
        templateUrl: require("customer/sections/goods-transfer/goods-transfer-list.html"),
        controller: "GoodsTransferListController",
        controllerAs: "goodsTransferListCtrl",
        authenticate: true,
        allowsSalesRepUserWithoutCustomerSelected: true,
        defaultSearchSection: "goodsTransferList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("My Goods Transfers");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("My Goods Transfers");
            }
        }
    })
    .state("goodsTransferDetails", {
        url: "/goods-transfer/:id?inventory_quantity_min&inventory_quantity_max",
        templateUrl: require("customer/sections/goods-transfer/goods-transfer-details.html"),
        controller: "GoodsTransferDetailsController",
        controllerAs: "goodsTransferDetailsCtrl",
        authenticate: true,
        allowsSalesRepUserWithoutCustomerSelected: true,
        defaultSearchSection: "goodsTransferDetails",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Goods Transfer Details");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Goods Transfer Details");
            }
        }
    })
    .state("paymentSettings", {
        url: "/payment-settings?tab",
        templateUrl: require("customer/sections/payment-settings/payment-settings.html"),
        controller: "CustomerPaymentSettingsController",
        controllerAs: "paymentSettingsCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Payment settings");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Payment settings");
            }
        }
    })
    .state("configurePreAuthorizedPayment", {
        url: "/configure-pre-authorized-payment/:id?cart",
        templateUrl: require("customer/sections/payment-settings/configure-pre-authorized-payment.html"),
        controller: "ConfigurePreAuthorizedPaymentController",
        controllerAs: "configurePreAuthorizedPaymentCtrl",
        authenticate: true,
        defaultSearchSection: "invoiceList",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Configure Pre-Authorized Payment");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Configure Pre-Authorized Payment");
            }
        }
    })
    .state("registration", {
        url: "/registration?retailer&token&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&unpaid_invoices",
        templateUrl: require("customer/sections/auth/quick-registration.html"),
        hideSmartBanner: true,
        controller: "SectionRegistration",
        controllerAs: "registerCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Registration");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title registration");
            },
            description: function(gettextCatalog) {
                var description =  gettextCatalog.getString("meta description registration");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description registration");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description registration");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description registration");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description registration");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords registration");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords registration");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords registration");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords registration");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta keywords registration");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("full-registration", {
        url: "/full-registration?retailer&token&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&unpaid_invoices",
        templateUrl: require("customer/sections/auth/registration.html"),
        css: [
            require("bower_components/angular-tree-control/css/tree-control.css"),
            require("bower_components/angular-tree-control/css/tree-control-attribute.css"),
            require("assets/css/tree-wegotrade.css")
        ],
        hideSmartBanner: true,
        controller: "SectionFullRegistration",
        controllerAs: "registerCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Registration");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title full-registration");
            },
            description: function(gettextCatalog) {
                var description = gettextCatalog.getString("meta description full-registration");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description full-registration");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description full-registration");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description full-registration");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description full-registration");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords full-registration");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords full-registration");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords full-registration");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords full-registration");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta keywords full-registration");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("stocks", {
        url: "/stocks?search&vendorId&catalog&product&categories&view&tab&lastCatalog",
        templateUrl: require("customer/sections/stock/stock.html"),
        controller: "SectionStocks",
        controllerAs: "stocksCtrl",
        authenticate: true,
        defaultSearchSection: "stocks",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Products");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Products");
            }
        }
    })
    .state("shoppingCart", {
        url: "/shoppingCart",
        templateUrl: require("customer/sections/cart/shopping-cart.html"),
        controller: "SectionShoppingCart",
        controllerAs: "shoppingCartCtrl",
        authenticate: true,
        defaultSearchSection: "stocks",
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Shopping Cart");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Shopping Cart");
            }
        }
    })
    .state("orderConsolidation", {
        url: "/order-consolidation?search&source&order-item-type&delivery-date-start&delivery-date-end",
        templateUrl: require("customer/sections/order-consolidation/order-consolidation.html"),
        defaultSearchSection: "orderConsolidation",
        controller: "OrderConsolidationController",
        controllerAs: "orderConsolidationCtrl",
        authenticate: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Order Consolidation");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Order Consolidation");
            }
        }
    })
    .state("inventoryReport", {
        url: "/inventory-report",
        templateUrl: require("customer/sections/inventory-report/inventory-report.html"),
        defaultSearchSection: "stocks",
        controller: "InventoryReportController",
        controllerAs: "inventoryReportCtrl",
        authenticate: true,
        allowsSalesRepUserWithoutCustomerSelected: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Inventory Report");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Inventory Report");
            }
        }
    })
    .state("resetPassword", {
        url: "/reset-password?username&code&retailer&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&hideCode&unpaid_invoices",
        templateUrl: require("core/reset-password/reset-password.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "ResetPassword",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Reset Password");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title reset password");
            },
            description: function(gettextCatalog) {
                var description = gettextCatalog.getString("meta description reset password");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description reset password");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description reset password");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description reset password");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description reset password");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords reset password");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords reset password");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords reset password");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords reset password");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta description reset password");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("requestResetCode", {
        url: "/request-reset-code?retailer&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&unpaid_invoices",
        templateUrl: require("core/reset-password/request-code.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "RequestPasswordResetCode",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Request Reset Code");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title request reset code");
            },
            description: function(gettextCatalog) {
                var description = gettextCatalog.getString("meta description request reset code");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description request reset code");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description request reset code");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description request reset code");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description request reset code");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords request reset code");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords request reset code");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords request reset code");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords request reset code");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta keywords request reset code");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("forgotUsername", {
        url: "/forgot-username?retailer&stocks&catalog&vendorInvite&groupInvite&vendor&product&invoice&payment&unpaid_invoices",
        templateUrl: require("core/reset-password/forgot-username.html"),
        css: require("core/reset-password/reset-password.useable.css"),
        controller: "ForgotUsername",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("ForgotUsername");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("meta title forgot username");
            },
            description: function(gettextCatalog) {
                var description = gettextCatalog.getString("meta description forgot username");

                if (APP_OWNER === "jemangequebec") {
                    description = gettextCatalog.getString("JEMANGEQUEBEC - meta description forgot username");
                }
                else if (APP_OWNER === "gromec") {
                    description = gettextCatalog.getString("GROMEC - meta description forgot username");
                }
                else if (APP_OWNER === "atlantis") {
                    description = gettextCatalog.getString("ATLANTIS - meta description forgot username");
                }
                else if (APP_OWNER === "bloom") {
                    description = gettextCatalog.getString("BLOOM - meta description forgot username");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return description;
            },
            keywords: function(gettextCatalog) {
                var keywords = gettextCatalog.getString("meta keywords forgot username");

                if (APP_OWNER === "jemangequebec") {
                    keywords = gettextCatalog.getString("JEMANGEQUEBEC - meta keywords forgot username");
                }
                else if (APP_OWNER === "gromec") {
                    keywords = gettextCatalog.getString("GROMEC - meta keywords forgot username");
                }
                else if (APP_OWNER === "atlantis") {
                    keywords = gettextCatalog.getString("ATLANTIS - meta keywords forgot username");
                }
                else if (APP_OWNER === "bloom") {
                    keywords = gettextCatalog.getString("BLOOM - meta keywords forgot username");
                }
                // TODO WHITE_LABEL: duplicate previous IF

                return keywords;
            }
        }
    })
    .state("profile-edit", {
        url: "/profile-edit",
        templateUrl: require("core/profile/profile.html"),
        controller: "Profile",
        controllerAs: "profileCtrl",
        authenticate: true,
        allowAll: true,
        params: {
            forceModalRedirect: null
        },
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Profile");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Profile");
            }
        }
    })
    .state("customer-edit", {
        url: "/customer-edit",
        templateUrl: require("customer/sections/auth/customer.html"),
        controller: "CustomerEdit",
        authenticate: true,
        params: {
            forceModalRedirect: null
        },
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customer-Profile-General-Mobile-Title");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Customer-Profile-General-Mobile-Title");
            }
        }
    })
    .state("support", {
        onEnter: function($http, $state, semver, MOBILE_APP_VERSION) {
            $http({
                method: "GET",
                url: appConfig.API_SERVER + "/auth/customer/support/"
            }).then(
                function(response) {
                    if (MOBILE_APP_VERSION && semver.gte(MOBILE_APP_VERSION, "0.1.5") && cordova && cordova.platformId === "ios") {
                        // Open in browser to avoid crash
                        cordova.InAppBrowser.open(response.data, "_system");
                        $state.go("home");
                    } else {
                        window.location = response.data;
                    }
                }
            );
        }
    })
    .state("terms-of-service", {
        url: "/terms-of-service",
        templateUrl: require("core/terms-of-service/terms-of-service.html"),
        controller: "TermsOfService",
        authenticate: true,
        hideBackButton: true,
        allowAll: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Terms of service");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Terms of service");
            }
        }
    })
    .state("customer-listing", {
        url: "/customers?page&search&vendor&catalog&product&vendorInvite&groupInvite&invoice&payment&unpaid_invoices",
        templateUrl: require("customer/sections/user-customer/user-customer-list.html"),
        controller: "UserCustomerController",
        controllerAs: "userCustomerCtrl",
        defaultSearchSection: "customer-listing",
        authenticate: true,
        allowsUserWithoutCustomerSelected: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Customers");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Customers");
            }
        }
    })
    .state("partnership-listing", {
        url: "/partnerships?page&search&vendor&catalog&product&vendorInvite&groupInvite&invoice&payment&unpaid_invoices&last_invoice_date_start&last_invoice_date_end&last_invoice_date_filter&has_last_invoice&partnership_last_order_date_start&partnership_last_order_date_end&partnership_last_order_date_filter&has_partnership_last_order&delivery_date_start&delivery_date_end&deadline_date_start&deadline_date_end&order_deadline_filter&next_delivery_has_ordered&tags",
        templateUrl: require("customer/sections/user-partnership/user-partnership-list.html"),
        controller: "UserPartnershipController",
        controllerAs: "userPartnershipCtrl",
        defaultSearchSection: "partnership-listing",
        authenticate: true,
        allowsUserWithoutCustomerSelected: true,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Partnerships");
        },
        meta: {
            title: function(gettextCatalog) {
                return gettextCatalog.getString("Partnerships");
            }
        }
    })
    .state("external-login", {
        url: "/external-login?payload",
        templateUrl: require("customer/sections/auth/external-login.html"),
        controller: "ExternalLoginController",
        controllerAs: "externalLoginCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return "";
        }
    })
    .state("404", {
        url: "/404",
        templateUrl: require("core/http-error-response/not-found.html"),
        controller: "NotFoundController",
        controllerAs: "notFoundCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Page not found");
        }
    })
    .state("502", {
        url: "/maintenance",
        templateUrl: require("core/http-error-response/maintenance.html"),
        controller: "MaintenanceController",
        controllerAs: "maintenanceCtrl",
        authenticate: false,
        title: function(gettextCatalog) {
            return gettextCatalog.getString("Maintenance in progress");
        }
    });

    $urlRouterProvider
    .when("/", "home")
    .when(/index\.html$/, ["$state", function($state) {
        _.defer(function() {
            $state.go("home");
        });
    }])
    // Next are deprecated routing redirection
    .when(/companies/, ["$state", "common", function($state, common) {
        _.defer(function() {
            $state.go("customer-listing", common.getObjectParamFromStringParamsURL());
        });
    }])
    .when(/company-edit/, ["$state", "common", function($state, common) {
        _.defer(function() {
            $state.go("customer-edit", common.getObjectParamFromStringParamsURL());
        });
    }])
    .otherwise("404");
})

.run(function($rootScope, $state, $cookies, $q, $http, CssUseableActivator, RetailerUserInfoService, UserService, common, gettextCatalog, appConfig) {
    UserService.initUser();
    CssUseableActivator.init();

    function validateState(event, toState, toParams, fromState, fromParams, user) {
        if (!user) {
            if (toState.name != "login") {
                event.preventDefault();
                $state.go("login");
            }
            return;
        }

        if (toState.name !== "terms-of-service" && user.have_to_agree_tos) {
            event.preventDefault();
            $state.go("terms-of-service");
            return;
        }
        else if (
            toState.name !== "customer-listing"
            && toState.name !== "partnership-listing"
            && !toState.allowAll
            && !user.customer
            && toState.allowsSalesRepUserWithoutCustomerSelected
            && !user.global_dedicated_vendor_id
        ) {
            event.preventDefault();
            $state.go("customer-listing", {
                vendorInvite: toParams.vendorInvite,
                groupInvite: toParams.groupInvite,
                vendor: toParams.vendorId || toParams.vendor,
                catalog: toParams.catalog,
                product: toParams.product,
                invoice: toParams.invoice,
                payment: toParams.payment
            });
            return;
        }
        else if (toState.name === "terms-of-service" && !user.have_to_agree_tos) {
            event.preventDefault();
            if (fromState.name !== "") {
                $state.go(fromState, fromParams);
            }
            else {
                $state.go("home");
            }
            return;
        }
        else if (toState.name === "login") {
            event.preventDefault();
            $state.go("home");
            return;
        }
    }

    $rootScope.UpdateNumbers = function(url, bounce) {
        var deferred = $q.defer();
        if (UserService.isLoggedIn()) {
            $http({
                method: "GET",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + url
            }).then(function(response) {
                if ($rootScope.CurrentNumbers) {
                    if (bounce && $rootScope.CurrentNumbers.CartItems !== response.data.CartItems) {
                        $rootScope.$broadcast("OrdersCountChanged");
                    }
                }
                else {
                    $rootScope.CurrentNumbers = {}
                }
                angular.extend($rootScope.CurrentNumbers, response.data);
                $rootScope.$broadcast("CurrentNumbersUpdated");
                deferred.resolve(response);
            }, deferred.reject);
        }
        else {
            $rootScope.CurrentNumbers = [];
        }
        return deferred.promise;
    };

    $rootScope.UpdateCurrentNumbers = function(bounce) {
        return $rootScope.UpdateNumbers("/catalog/customer/current-number/", bounce);
    }

    $rootScope.UpdateCartItemsNumber = function(bounce) {
        return $rootScope.UpdateNumbers("/catalog/customer/current-number/cart-items/", bounce);
    };

    $rootScope.$on("UserUpdated", function(event, user, updateCurrentNumber) {
        if (updateCurrentNumber) {
            $rootScope.UpdateCurrentNumbers();
        }

        if (user.customer) {
            $rootScope.preferredMode = user.customer.preferred_mode;
            $rootScope.promotionMode = user.customer.promotion_mode;
        }
    });

    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeStart to " + toState.name + " - fired when the transition begins. toState, toParams : \n", toState, toParams);
        $rootScope.fromState = {};
        $rootScope.fromParams = {};

        var isModalOpened = ($(".modal").data("bs.modal") || {}).isShown;
        if (toState.name === "502" ) {
            return;
        }
        else if (isModalOpened && !toParams.forceModalRedirect) {
            event.preventDefault();
            $state.go(fromState, fromParams);
            return;
        }
        else if (toState.name === "orderConfirmation" && !toParams.order) {
            event.preventDefault();
            $state.go("home", toParams);
            return;
        }
        else if (UserService.isLoggedIn()) {
            if ($rootScope.user) {
                validateState(event, toState, toParams, fromState, fromParams, $rootScope.user);
            }
            else {
                UserService.isUserFetched().then(
                    function onSuccess(user) {
                        validateState(event, toState, toParams, fromState, fromParams, user);
                    }
                );
            }
            $rootScope.fromState = fromState;
            $rootScope.fromParams = fromParams;
            return;
        }
        else if (toState.authenticate) {
            event.preventDefault();
            $rootScope.toState = toState;
            $rootScope.toParams = toParams;
            $state.go("login", {
                vendorInvite: toParams.vendorInvite,
                groupInvite: toParams.groupInvite,
                vendor: toParams.vendorId || toParams.vendor,
                catalog: toParams.catalog,
                product: toParams.product,
                invoice: toParams.invoice,
                payment: toParams.payment,
                unpaid_invoices: toParams.unpaid_invoices
            });
            return;
        }
        else {
            // When user is not authenticate and navigate between page not requiring to be,
            //   we transmit these parameter between login / registration / forget password, user / request-code
            if (!toParams.token)
                toParams.token = fromParams.token;

            if (!toParams.vendorInvite)
                toParams.vendorInvite = fromParams.vendorInvite;

            if (!toParams.groupInvite)
                toParams.groupInvite = fromParams.groupInvite;

            if (!toParams.product)
                toParams.product = fromParams.product;

            if (!toParams.vendor)
                toParams.vendor = fromParams.vendor;

            if (!toParams.catalog)
                toParams.catalog = fromParams.catalog;

            if (!toParams.retailer)
                toParams.retailer = fromParams.retailer;

            if (!toParams.stocks)
                toParams.stocks = fromParams.stocks;

            if (!toParams.invoice)
                toParams.invoice = fromParams.invoice;

            if (!toParams.payment)
                toParams.payment = fromParams.payment;

            if (!toParams.unpaid_invoices)
                toParams.unpaid_invoices = fromParams.unpaid_invoices;
        }
    });

    // make debugging a hell of a lot easier
    $rootScope.$on("$stateChangeError", console.log.bind(console));

    $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeError - fired when an error occurs during transition.");
        console.log(arguments);
    });

    $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
        common.scrollToTop();
        // Google Analytics(ga) - to support Single Page App - https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
        gtag('set', 'page_path',  "/" + toState.name);
        gtag('event', 'page_view');

        console.log("$stateChangeSuccess to " + toState.name + "- fired once the state transition is complete.");
        $rootScope.CurrentStateControllerName = toState.controller;
        $rootScope.UpdateCurrentNumbers();

        if (toState.meta && toState.meta.title) {
            $rootScope.meta.pageTitle = toState.meta.title(gettextCatalog);
        }
        else {
            $rootScope.meta.pageTitle = gettextCatalog.getString("default meta title");
        }

        if (!toState.authenticate) {
            if (toState.meta && toState.meta.description && toState.meta.keywords) {
                $rootScope.meta.description = toState.meta.description(gettextCatalog);
                $rootScope.meta.keywords = toState.meta.keywords(gettextCatalog);
            }
            else {
                $rootScope.meta.description = gettextCatalog.getString("default meta description");
                $rootScope.meta.keywords = gettextCatalog.getString("default meta keywords");
            }
        }
    });

    $rootScope.$on("$viewContentLoaded", function(event) {
        console.log("$viewContentLoaded - fired after dom rendered", event);
    });

    $rootScope.$on("$stateNotFound", function(event, unfoundState, fromState, fromParams) {
        console.log("$stateNotFound " + unfoundState.name + "  - fired when a state cannot be found by its name.");
        console.log(unfoundState, fromState, fromParams);
    });
})
.run(function(PreviousStateService) {
    PreviousStateService.init();
});



//////////////////
// WEBPACK FOOTER
// ./customer/customer.route.js
// module id = 717
// module chunks = 0